// Receive Mutations

export const updateReceiveList = (state, payload) => {
  state.receiveList = payload
}

export const fetchReceiveInfo = (state, payload) => {
  state.receiveInfo = payload
}

export const fetchPendingReceiveCount = (state, payload) => {
  state.pendingReceiveCount = payload
}
